<div class="bloc-ingredients">
  <div class="background-ingredients">
    <div cdkDropList *ngIf="formGroups" (cdkDropListDropped)="reorder($event)">
      <div class="column-type" *ngIf="usedIngredientTypes.size > 1">
        <mat-icon cdkDragHandle class="rotate-icon">compare_arrows</mat-icon>
        <mat-form-field appearance="fill" class="field-type form-field-no-header">
          <mat-select id="RecipesModifyIngredientBlocTypeBtn{{ index }}" [formControl]="typeControl">
            <div [id]="'RecipesModifyIngredientBlocLst{{index}}'">
              <mat-option *ngFor="let type of typesAvailable" [value]="type.key">
                {{ type.translatedName }}
              </mat-option>
            </div>
          </mat-select>
        </mat-form-field>
        <div class="spacer"></div>
      </div>

      <div (mousedown)="$event.stopPropagation()" class="headers">
        <div class="column-drag"></div>
        <div class="column-name">{{ 'RECIPES_EDIT.INGREDIENTS.DESCRIPTION' | translate }}</div>
        <div class="column-quantity">{{ 'RECIPES_EDIT.INGREDIENTS.QUANTITY' | translate }}</div>
        <div class="column-ingredients">{{ 'RECIPES_EDIT.INGREDIENTS.INGREDIENT' | translate }}</div>
        <div class="column-food">{{ 'RECIPES_EDIT.INGREDIENTS.MARKETING_FOOD' | translate }}</div>
        <div class="column-actions">&nbsp;</div>
      </div>
      <ng-container *ngFor="let formGroupIngredient of formGroups; let index = index" [formGroup]="formGroupIngredient">
        <div cdkDrag (mousedown)="$event.stopPropagation()">
          <div *ngIf="formGroupIngredient.value.type === type || formGroupIngredient.value.type === null">
            <div class="ingredient-line">
              <mat-icon cdkDragHandle class="rotate-icon" id="RecipesModifyIngredientBlocMoveBtn{{ index }}">compare_arrows</mat-icon>
              <mat-form-field
                appearance="fill"
                class="column-name form-field-no-header"
                (keyup.enter)="focusNextLine(index)"
                (keydown.enter)="$event.preventDefault()"
              >
                <input
                  id="RecipesModifyIngredientDescriptionTxt"
                  matInput
                  type="text"
                  formControlName="applicationDescription"
                  #ingredientLineNameField
                  (paste)="fastInput($event, index)"
                />
              </mat-form-field>
              <div class="column-quantity">
                <mat-form-field
                  appearance="fill"
                  class="field-quantity form-field-no-header form-field-number"
                  (keyup.enter)="focusNextLine(index)"
                  (keydown.enter)="$event.preventDefault()"
                >
                  <input matInput type="number" id="RecipesModifyIngredientQuantityNbr" formControlName="quantity" min="0" />
                </mat-form-field>
                <mat-form-field appearance="fill" class="field-unit form-field-no-header">
                  <mat-select id="RecipesModifyIngredientMeasureUnitBtn" formControlName="unit">
                    <div id="RecipesModifyIngredientMeasureUnitLst">
                      <mat-option></mat-option>
                      <mat-option *ngFor="let unit of unitsArray" [value]="unit.key">
                        {{ unit.labelInt || unit.key }}
                      </mat-option>
                    </div>
                  </mat-select>
                </mat-form-field>
              </div>
              <mat-form-field
                appearance="fill"
                class="column-ingredients form-field-no-header"
                (keyup.enter)="focusNextLine(index)"
                (keydown.enter)="$event.preventDefault()"
              >
                <input matInput type="text" id="RecipesModifyIngredientTitleTxt{{ index }}" formControlName="endFreeText" />
              </mat-form-field>
              <span class="column-food">
                <app-marketing-food-form-field
                  [foodFormControl]="getFoodFormControl(formGroupIngredient)"
                  [requestedFoodFormControl]="getRequestedFoodFormControl(formGroupIngredient)"
                  [marketingFoods]="marketingFoods"
                  [suggestedMarketingFoods]="getSuggestedMarketingFoods(formGroupIngredient)"
                ></app-marketing-food-form-field>
              </span>
              <div class="column-actions">
                <i
                  class="fas fa-trash space-l-l"
                  aria-hidden="true"
                  id="RecipesModifyIngredientDeleteBtn{{ index }}"
                  (click)="delete(index)"
                ></i>
              </div>
            </div>
            <app-help-fast-input
              class="help-fast-input"
              *ngIf="
                index === 0 &&
                (formGroups[1]?.controls?.applicationDescription?.value === null ||
                  formGroups[1]?.controls?.applicationDescription?.value === '') &&
                formGroups.length === 1
              "
            ></app-help-fast-input>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="footer">
      <div>
        <button mat-button class="btn btn-transparent add-button" id="RecipesModifyIngredientAddBtn" (click)="newLine()">
          {{ 'RECIPES_EDIT.INGREDIENTS.NEW_LINE' | translate }}
          <i class="fas fa-plus space-l-m space-v-s" aria-hidden="true"></i>
        </button>
      </div>
      <div *ngIf="usedIngredientTypes.size > 1">
        <button mat-button class="btn delete-button" id="RecipesModifyIngredientBlocDeleteBtn" (click)="removeBlock()">
          {{ 'RECIPES_EDIT.INGREDIENTS.DELETE_BLOCK' | translate }}
          <i class="fas fa-trash space-l-m space-v-s" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</div>
